export const NAME = `ENTITY`
export const NAME_PREFIX = `ENTITY_`
